// fetch wrapper: resolves the parsed body on 2xx, rejects with it otherwise.
// Tolerates non-JSON bodies (HTML 5xx pages, login redirects, empty 204) — those
// resolve to {} so callers fall back to their own message instead of surfacing a
// raw "Unexpected token '<'" JSON parser error to the user.
export const apiFetch = (url, options = {}) =>
  fetch(url, { credentials: 'same-origin', ...options }).then((r) =>
    r.json().catch(() => ({})).then((body) => (r.ok ? body : Promise.reject(body)))
  )
